<template>
  <div class="ml">
    <h1>Step Actions</h1>
    <div>
      <el-button @click="openStepDatamodelUploadModel" type="primary">Step Datamodel</el-button>
      <el-button @click="openStepAccountManagementModel" type="primary">Step Account Management</el-button>
      <el-button @click="openCSVUploadModel" type="primary">+ Add csv Step Journeys</el-button>
      <!-- <el-button @click="openMLModel(0)" type="primary">+ Add new ML</el-button> -->
      <!-- <el-button @click="openMLApplyModal()" type="primary">Apply ML</el-button> -->
    </div>
  </div>
</template>
<script>
import SingleMLModal from "@/modals/SingleMLModal.vue";
import ApplyMlModal from "@/modals/ApplyMLModal.vue";
import SingleMLCsvModal from "@/modals/SingleMLCsvModal.vue";
import StepDatamodelModal from "@/modals/StepDatamodelModal.vue";
import StepAccountManagementModal from "@/modals/StepAccountManagementModal.vue";
import ApiService from "@/services/ApiService";
export default {
  name: "MLs",
  data() {
    return {
      keyword: "",
      showType: "",
      data: [],
      newAutomation: {},
      loading: false,
    };
  },
  methods: {
    getMLs() {
      ApiService.mlApi.getMlModels().then((resp) => {
        this.data = resp.data;
      });
    },
    goto(path) {
      path = "/members/automations/" + path;
      this.$router.push(path);
    },
    openMLApplyModal() {
      this.$modal.show(
        ApplyMlModal,
        {
          options: {
            // profilePicture: true,
          },
          // id,
          // isLaunchModal: isLaunchModal,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          width: 1150,
          height: "auto",
          adaptive: true,
          clickToClose: false,
        },
        {
          // "before-close": this.getMLs,
        }
      );
    },
    openMLModel(id) {
      // if (!isLaunchModal) isLaunchModal = false;

      this.$modal.show(
        SingleMLModal,
        {
          options: {
            // profilePicture: true,
          },
          id,
          // isLaunchModal: isLaunchModal,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          width: 1150,
          height: "auto",
          adaptive: true,
          clickToClose: false,
        },
        {
          "before-close": this.getMLs,
        }
      );
    },
    openCSVUploadModel() {
      this.$modal.show(
        SingleMLCsvModal,
        {
          options: {},
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          width: 1150,
          height: "auto",
          adaptive: true,
          clickToClose: false,
        },
        {
          "before-close": this.getMLs,
        }
      );
    },
    openStepDatamodelUploadModel() {
      this.$modal.show(
        StepDatamodelModal,
        {
          options: {},
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          width: 1150,
          height: "auto",
          adaptive: true,
          clickToClose: false,
        },
        {
          "before-close": this.getMLs,
        },
      );
    },
    openStepAccountManagementModel() {
      this.$modal.show(
        StepAccountManagementModal,
        {
          options: {},
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          width: 1150,
          height: "auto",
          adaptive: true,
          clickToClose: false,
        },
      );
    },
    deleteML(id) {
      ApiService.mlApi.deleteItem(id).then(() => {
        this.$notify.info({
          title: "Saved",
          message: "Deleted!",
        });
        this.getMLs();
      });
    },
    duplicate(id) {
      ApiService.mlApi.duplicateItem(id).then(() => {
        this.$notify.info({
          title: "Duplicated!",
          message: "Done",
        });
        this.getMLs();
      });
    },
    // updateField(field, id, value) {
    //   ApiService.mlApi.updateField(field, { id: id, value: value }).then(() => {
    //     this.$notify.info({
    //       title: "Automation status has been updated",
    //       message: "Updated!",
    //     });
    //     this.getMLs();
    //   });
    // },
  },
  mounted() {
    this.getMLs();
  },
};
</script>
<style>
.smallFont {
  font-size: 11px;
}
</style>
